import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vimeo-player',
  props: {
    id: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  id: string;
}



const loaded = ref<boolean>(false);

const embedURL = computed(() => {
  return props.id
    ? "https://player.vimeo.com/video/" + props.id + "?autopause=0"
    : null;
});

const frameLoaded = () => {
  loaded.value = true;
};

const __returned__ = { props, loaded, embedURL, frameLoaded, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})